import { DirectiveLandingPage } from 'components/directive/directiveLandingPage/DirectiveLandingPage'
import { createGetDirectiveLPStaticProps } from 'components/directive/utils/createGetDirectiveLPStaticProps'
import { DirectiveLPPageProps } from 'components/directive/utils/types'

export default function Page(props: DirectiveLPPageProps) {
  return <DirectiveLandingPage variant="legacy" {...props} />
}

export const getStaticProps = createGetDirectiveLPStaticProps('FUNERAL')
